import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center">
      <div>
        <Sparkles className="w-10 h-10 text-primary mx-auto mb-4" />
        <h1 className="font-heading text-5xl mb-3">404</h1>
        <p className="text-zinc-400 mb-6">Diese Seite glänzt leider nicht.</p>
        <Link to="/" className="text-primary hover:underline" data-testid="notfound-home-link">
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
